import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var Bus = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("path", {
    d: "M21.004 7.975V6c0-2.206-1.794-4-4-4h-10c-2.206 0-4 1.794-4 4v1.998l-.076.004A1 1 0 002 9v2a1 1 0 001 1h.004v6c0 .735.403 1.372.996 1.72V21a1 1 0 001 1h1a1 1 0 001-1v-1h10v1a1 1 0 001 1h1a1 1 0 001-1v-1.276A1.994 1.994 0 0021.004 18v-6a1 1 0 001-1V9.062a1.006 1.006 0 00-.072-.455c-.203-.487-.635-.604-.928-.632zM19.006 18H5.004v-5H19.005l.001 5zM11.004 7v4h-6V7h6zm8 0v4h-6V7h6zm-12-3h10c.736 0 1.375.405 1.722 1H5.282c.347-.595.986-1 1.722-1z",
    key: "k0"
  }), React.createElement("circle", {
    cx: 7.5,
    cy: 15.5,
    r: 1.5,
    key: "k1"
  }), React.createElement("circle", {
    cx: 16.5,
    cy: 15.5,
    r: 1.5,
    key: "k2"
  }));
});
Bus.displayName = 'Bus';
export var BusDimensions = {
  height: 24,
  width: 24
};